<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>个人赛赛务管理</el-breadcrumb-item>
      <el-breadcrumb-item>个人赛程</el-breadcrumb-item>
      <el-breadcrumb-item>区域决选</el-breadcrumb-item>
    </el-breadcrumb>
    <el-page-header @back="goBack"></el-page-header>
    <innerPage ref="innerRef"></innerPage>
  </div>
</template>

<script>
import innerPage from './rematch_raceManagement_innerPage.vue'
export default {
  components: {
    innerPage
  },
  data () {
    return {
    }
  },
  created () {
    setTimeout(() => {
      this.$refs.innerRef.getDistrict()
      this.$refs.innerRef.getDataList()
    })
  },
  methods: {
    goBack () {
      this.$router.back()
    }
  }
}
</script>

<style lang="less" scoped>
</style>
